module.exports = __webpack_public_path__ + "resource/img/edit-ava.abd82cec.svg";